import React from "react"
import PropTypes from "prop-types"
import PreparerInfo from "./PreparerInfo"
import IdentityInfo from "./IdentityInfo"

const propTypes = {
    i9: PropTypes.object
}

export default class Section2 extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: props.i9
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            const _this = this

            this.setState({
                i9: nextProps.i9
            })
        }
    }

    render() {
        return (
            <div className="Section2">
                <IdentityInfo i9={this.state.i9} />
            </div>
        )
    }
}

Section2.propTypes = propTypes
